function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 11.5386V23.0386C2 23.7016 2.26339 24.3375 2.73223 24.8063C3.20107 25.2752 3.83696 25.5386 4.5 25.5386",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 14.0386H22",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 19.0386H22",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7 23.0386V8.53857C7 8.27336 7.10536 8.019 7.29289 7.83147C7.48043 7.64393 7.73478 7.53857 8 7.53857H27C27.2652 7.53857 27.5196 7.64393 27.7071 7.83147C27.8946 8.019 28 8.27336 28 8.53857V23.5386C28 24.069 27.7893 24.5777 27.4142 24.9528C27.0391 25.3279 26.5304 25.5386 26 25.5386H4.5C4.8283 25.5386 5.15339 25.4739 5.45671 25.3483C5.76002 25.2226 6.03562 25.0385 6.26777 24.8063C6.49991 24.5742 6.68406 24.2986 6.8097 23.9953C6.93534 23.692 7 23.3669 7 23.0386V23.0386Z",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgEventfeedUnselected = function SvgEventfeedUnselected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEventfeedUnselected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eventfeed-unselected.002229d8.svg";
export { ForwardRef as ReactComponent };